module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-wrap--medium"
  }, [(!!_vm.notes.length) ? _c('ol', {
    staticClass: "u-mt2"
  }, _vm._l((_vm.notes), function(item, index) {
    return _c('li', [_c('note', {
      attrs: {
        "note": item.node
      }
    })], 1)
  })) : _c('div', {
    staticClass: "u-richtext u-richtext--scale u-mt4 "
  }, [_c('p', [_vm._v("There are no notes for " + _vm._s(_vm.resourceName) + ".")])]), _vm._v(" "), (_vm.hasNextPage) ? _c('button', {
    staticClass: "Notes-more u-mt2",
    on: {
      "click": _vm.addNotes
    }
  }, [_c('icon', {
    attrs: {
      "icon": "plus"
    }
  }), _vm._v("\n    View more notes\n  ")], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ff68a64","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/vue/components/note-listing.vue
// module id = 344
// module chunks = 0